import React, { useEffect } from "react";
import { Row, Col, Slider, Loader } from "@kaleyra/emmy";
import Styles from './index.module.scss';
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

export type DispatchPropsType = {
    onClose: () => void;
    onLoad: () => void;
};

export type MapStatePropsType = {
    templateViewDetails: any;
    inProgress: boolean;
    data: any;
};



const VerifiedSMSView: React.FC<MapStatePropsType & DispatchPropsType> = ({
    onClose, onLoad, templateViewDetails, inProgress, data
}) => {

    const { t } = useTranslation();
    const { smsVerifiedSMSData } = data;
    let vsmsData: Record<string, string>
    if (!isEmpty(smsVerifiedSMSData?.data?.res)) {
        vsmsData = smsVerifiedSMSData?.data?.res[0];
    }

    useEffect(() => {
        onLoad();
    }, [])




    const getBody = () => <>
        <div className={Styles.verifiedContainer}>
            <p className={Styles.headerText}>{t('BLD01524')}</p>
            <p className={Styles.sectionText}>{t('BLD01528')}</p>
            <p className={Styles.title} >{t('BLD01038')}</p>
            <div className={Styles.infoContainer}>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD01516')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {vsmsData?.brand_name}
                    </Col>
                </Row>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD1726')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {vsmsData?.website}
                    </Col>
                </Row>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD01509')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {vsmsData?.contact_name}
                    </Col>
                </Row>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD00005')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {vsmsData?.email}
                    </Col>
                </Row>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD00607')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {vsmsData?.description}
                    </Col>
                </Row>
                <p className={Styles.title}>{t('BLD01514')}</p>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD00607')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {smsVerifiedSMSData?.data?.senders?.filter((sender: any) => sender.vsms_status !== "0").map((item: any) => item?.sender)?.join(', ')}
                    </Col>
                </Row>
                <p className={Styles.title}>{t('BLD01029')}</p>
                <p className={Styles.headerText} style={{ padding: "0px" }}>{t('BLD01030')}</p>
                <Row>
                    <Col className={Styles.infoTitle} size={4}>
                        {t('BLD01517')}
                    </Col>
                    <Col className={Styles.infoValue} size={8}>
                        {vsmsData?.agent_name}
                    </Col>
                </Row>
            </div>
        </div>
    </>




    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            title={t('BLD01502')}
        >
            <div className={Styles.container}>{(isEmpty(templateViewDetails) || inProgress) ? <Loader /> : getBody()}</div>
        </Slider >
    );


}

export default VerifiedSMSView;